<template>
  <div class="price__cards">
    <div class="container container--fluid">
      <div class="row">
        <div class="col col--12">
          <price-navigation :opts="{ currency, mode }" />
        </div>
      </div>
      <div class="row" v-if="config.length">
        <div class="col col--12">
          <div class="price__plan flex flex--justify-center">
            <base-card
              v-for="(card, idx) in config"
              :key="idx"
              :card="card"
              :opts="{ currency, mode }"
              v-if="currency !== null && mode !== null"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCard from "@/components/BaseCard";
import PriceNavigation from "@/components/PriceNavigation";
import { resolveInitialCurrency } from "@/utils/currencyDetect";
import settings from "@/assets/settings";
export default {
  name: "App",
  provide() {
    return {
      handleMode: this.handleMode,
      handleCurrency: this.handleCurrency,
      rootMedia: () => this.media,
    };
  },
  data() {
    return {
      settings: [],
      media: window.innerWidth,
      calculator: null,
    };
  },

  created() {
    this.settings = settings;

    this.calculator = window.Calculator;

    for (let i = 0; i < this.config.length; i++) {
      window[this.config[i].title] = {
        select: null,
        transfer: null,
        price: null,
        storage: this.config[i].storage,
      };
    }

    window.addEventListener("click", this.handleCloseSelect);
  },

  mounted() {
    this.applyInitialCurrency();

    this.$nextTick(() => {
      window.addEventListener("resize", this.handleMedia);
    });
    // getSettings().then(s => this.settings = s)
  },

  computed: {
    config() {
      return this.settings;
    },
    mode: {
      get() {
        return this.calculator ? this.calculator.mode : null;
      },
      set(val) {
        if (this.calculator) this.calculator.mode = val;
      },
    },
    currency: {
      get() {
        return this.calculator ? this.calculator.currency : null;
      },
      set(val) {
        if (this.calculator) this.calculator.currency = val;
      },
    },
  },

  methods: {
    applyInitialCurrency() {
      if (!this.calculator) return;

      const initial = resolveInitialCurrency();
      this.currency = initial;

      this.$nextTick(() => {
        if (typeof this.calculator.handleCurrency === "function") {
          this.calculator.handleCurrency(initial.split(" ")[0]);
        }
      });
    },
    handleCurrency(val) {
      this.currency = val;

      if (typeof this.calculator?.handleCurrency === "function") {
        this.calculator.handleCurrency(val.split(" ")[0]);
      }
    },
    handleMode(val) {
      this.mode = val;
    },
    handleMedia() {
      this.media = window.innerWidth;
    },
  },

  components: {
    BaseCard,
    PriceNavigation,
  },
};
</script>
<style lang="scss"></style>
